<div class="chat-bot-container" [class.expanded]="isExpanded()">
  @if (chatBotService.isLeftPanelOpen()) {
    <div class="backdrop" (click)="closeLeftPanel()"></div>
  }
  <!-- Chat Header -->
  <miq-chat-bot-header
    [showMenuBtn]="true"
    [isInprogress]="isResponseInProgress() || isHistoryLoading()"
    (emitCloseChat)="closeChat()"
    [windowSizeIncreased]="isExpanded()"
    (emitWindowSize)="toggleWindowSize()"
    (emitNewSession)="startNewSession()"
  ></miq-chat-bot-header>

  <div class="chat-bot-left-panel" [class.hidden]="!chatBotService.isLeftPanelOpen()">
    <miq-chat-left-panel
      (emitNewSession)="startNewSession()"
      [chatHistory]="chatHistory"
      (emitSelectedSession)="loadSavedSession($event)"
    ></miq-chat-left-panel>
  </div>

  <!-- Chat Body -->
  <div class="chat-bot-body" #chatBody>
    @if (!(sessionId() || isHistoryLoading())) {
      <div class="greeting-section">
        <div class="greeting-title">Hello {{ userInfo()?.firstName }},</div>
        <div class="greeting-subtitle">
          <p>{{ 'chat.howcanihelpyou' | translate }}</p>
        </div>
      </div>
    }
    <!--Default Prompts-->
    @if (!(sessionId() || isHistoryLoading())) {
      <div class="default-prompts">
        @for (prompt of defaultPrompts; track prompt) {
          <div class="default-prompt" [class.expanded]="isExpanded()" (click)="handlePromptClick(prompt)">
            {{ prompt }}
          </div>
        }
      </div>
    }

    <div class="conversation-section">
      @if (isHistoryLoading()) {
        <cbre-spinner-loading-indicator
          diameter="48"
          [description]="'loading' | translate"
        ></cbre-spinner-loading-indicator>
      } @else {
        @for (msg of messages(); track msg; let i = $index) {
          <miq-chat-conversation
            [message]="msg"
            [index]="i"
            (emitFeedback)="updateMessage($event, i)"
          ></miq-chat-conversation>
        }
      }
    </div>
  </div>
  <!-- Chat Input -->
  <div class="chat-input-section">
    <miq-chat-input
      #chatInput
      (sendMessage)="handleUserMessage($event)"
      [(message)]="chatInputValue"
      [isResponseInProgress]="isResponseInProgress() || isHistoryLoading()"
      (messageChange)="onMessageChange($event)"
    ></miq-chat-input>
  </div>
  <div
    class="chat-bot-prompts-panel"
    [class.hidden]="!chatBotService.isPromptsPanelOpen()"
    [class.expanded]="isExpanded()"
    >
    <miq-chat-prompts-panel
      [defaultPrompts]="defaultGroupByPrompts"
      [windowSizeIncreased]="isExpanded()"
      (emitPromptSelected)="handlePromptClick($event)"
      (emitToggleWindowSize)="togglePromptsWindowSize()"
      (emitStartNewSession)="startNewSession()"
      >
    </miq-chat-prompts-panel>
  </div>
</div>
